<template>
  <div>
    <modal-template
      v-show="toggle"
      @close="toggleInfoModal"
      class="override-modal"
    >
      <template #header>
        <i class="icon-ic_close" @click="toggleInfoModal" />
        <h3>{{ titulo }}</h3>
      </template>
      <template #body>
        <div class="has-text-centered">
          <p>{{ mensagem }}</p>
        </div>
      </template>
      <template #footer>
        <div class="columns absence">
          <b-button class="column confirm" @click="toggleInfoModal()">
            {{ $t('botoes.confirmar') }}
          </b-button>
        </div>
      </template>
    </modal-template>
  </div>
</template>

<script>
import ModalTemplate from './ModalTemplate'

export default {
  name: 'ConfirmarAtendimentoModal',
  components: { ModalTemplate },
  props: {
    toggle: {
      type: Boolean,
      default: false
    },
    titulo: {
      type: String,
      default: ''
    },
    mensagem: {
      type: String,
      default: ''
    }
  },
  methods: {
    toggleInfoModal() {
      this.$emit('closeModal', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
.absence {
  margin-bottom: 4px;
  margin: 0 auto;
  width: 90%;

  .confirm {
    margin: auto;
    box-sizing: border-box;
    height: 2.5rem;
    width: 12.5rem;

    color: var(--light-blue);
    border: 0.0625rem solid $light-blue;
    border-color: var(--light-blue);
    border-radius: 0.25rem;

    &:hover {
      color: var(--neutral-color-5);

      background-color: var(--light-blue);
      transition: all 0.2s;
    }
  }

  .cancel {
    color: var(--orange-dark);
    font-weight: 500;
    font-size: 0.875rem;
  }
}
</style>
